import React from "react";
import { Card } from "@mantine/core";
import { useGetMerchantChannelBalances } from "../../../../hooks/queries/useMerchantQueries";
import { useAirtelEnabled } from "../../../../hooks/useAirtelEnabled";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";
import airtelLogo from "../../../../assets/img/airtelmoneylogo.webp";

export default function AirtelBalanceCard() {
  const airtelEnabled = useAirtelEnabled();
  const { data, isLoading, isError, refetch } = useGetMerchantChannelBalances();

  if (!airtelEnabled) {
    return null;
  }

  if (isLoading) {
    return <StatCardSkeleton className="bg-red-50" />;
  }

  if (isError) {
    return (
      <Card className="bg-red-50 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load Airtel balance."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      icon={
        <img
          src={airtelLogo}
          alt="Airtel"
          className="w-4 h-4 object-contain rounded-sm"
        />
      }
      label="Airtel Balance"
      value={formatKES(data?.airtel)}
      className="bg-red-50"
    />
  );
}
